import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="mx-auto max-w-6xl px-4 py-6">
      <div className="flex flex-col items-center justify-between gap-4 text-center text-sm text-slate-500 sm:flex-row sm:text-left">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
          <p>&copy; {new Date().getFullYear()} Garissa Farmers Network. All rights reserved.</p>
          <p className="text-slate-400">
            Made with <span className="text-red-500">❤️</span> by{' '}
            <span className="font-semibold text-slate-600">EmpowerWithIT Solutions</span>
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/privacy" className="hover:text-primary transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-primary transition-colors">
            Terms
          </Link>
          <Link to="/contact" className="hover:text-primary transition-colors">
            Contact
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;

